import { Skeleton } from '@mui/material'

const DeviceDetailsLoading = () => (
  <>
    <Skeleton variant="text" height={48} sx={{ marginTop: 3 }} />
    <Skeleton variant="text" height={44} sx={{ marginTop: 1 }} />
    <Skeleton variant="rounded" height={316} sx={{ marginTop: 6, marginBottom: 2 }} />
  </>
)

export default DeviceDetailsLoading
